export default __webpack_public_path__ + "static/media/lower-icon.f3199a3e.svg";